module.exports = __webpack_public_path__ + "static/media/word-class-equipment.a67df819.jpg";